exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*!\n* BTN-ORDERED COMPONENT STYLES\n*/.group-ordered .dropdown-menu{top:0;left:100%}.group-ordered .dropdown-menu>li>a{color:#666;padding:3px 20px;border-top:none}.group-ordered .dropdown-menu>li .ordered-input{margin:.5em 1em}.group-ordered .btn{padding:.35rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./core/btn-ordered/btn-ordered.component.scss
// module id = 562
// module chunks = 0